import React, { useState } from "react";
import AdminTabelHeader from "../../components/layout/header/AdminTabelHeader";
import { useMutation, useQuery } from "react-query";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { useParams } from "react-router-dom";
import SpinerLoading from "../../../common/Loading/SpinerLoading";
import { useReducedMotion } from "motion/react";
import Swal from "sweetalert2";
import TraingleLoading from "../../../common/Loading/TraingleLoading";

const AdminContactAdd = () => {
  const [expertiseData, setExpertiseData] = useState({
    Address: "",
    phoneNumber: [""],
    email: [""],
    hours: "",
    id: "",
  });

  const addPhone = (type) => {
    if (type == "email") {
      setExpertiseData({
        ...expertiseData,
        email: [...expertiseData.email, ""],
      });
    } else {
      setExpertiseData({
        ...expertiseData,
        phoneNumber: [...expertiseData.phoneNumber, ""],
      });
    }
  };
  const { id } = useParams();

  const { data, isLoading } = useQuery({
    queryKey: "getExpertise",
    queryFn: () =>
      axios.get(`${BASEURL}contacts`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setExpertiseData({
        id: response?.id,
        hours: response?.working_hours,
        Address: response?.address,
        email: response?.email,
        phoneNumber: response?.phone,
      });
    },
  });

  const handleChange = (e, ind, type) => {
    const newData = { ...expertiseData };

    if (type == "phone") {
      newData.phoneNumber[ind] = e.target.value;
    } else if (type == "email") {
      newData.email[ind] = e.target.value;
    } else {
      newData[e.target.name] = e.target.value;
    }
    setExpertiseData(newData);
  };

  const mutation = useMutation({
    mutationFn: (values) => {
      return axios.post(`${BASEURL}contacts`, values);
    },
  });
  const updateMutation = useMutation({
    mutationFn: (values) => {
      return axios.put(`${BASEURL}contacts/${expertiseData?.id}`, values);
    },
    onSuccess: () => {
      Swal.fire({
        title: "Contact Updated successfully",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      });
    },
  });

  const handleSubmit = (e) => {
    const formdata = new FormData();

    formdata.append("address", expertiseData.Address);
    formdata.append("working_hours", expertiseData.hours);
    expertiseData.phoneNumber.map((item, ind) => {
      formdata.append(`phone[${ind}]`, item);
    });
    expertiseData.email.map((item, ind) => {
      formdata.append(`email[${ind}]`, item);
    });

    mutation.mutate(formdata);
  };

  const handleUpdate = (e) => {
    const formdata = new URLSearchParams();
    formdata.append("address", expertiseData.Address);
    formdata.append("working_hours", expertiseData.hours);
    expertiseData.phoneNumber.map((item, ind) => {
      formdata.append(`phone[${ind}]`, item);
    });
    expertiseData.email.map((item, ind) => {
      formdata.append(`email[${ind}]`, item);
    });
    updateMutation.mutate(formdata);
  };
  const deletehandlar = (ind, type) => {
    if (type == "email") {
      expertiseData?.email.splice(ind, 1);
    } else {
      expertiseData?.phoneNumber.splice(ind, 1);
    }
  };

  return (
    <div>
      <AdminTabelHeader title={"Edit contact details"} btnStatus={false} />
      {(mutation.isLoading || updateMutation.isLoading) && <TraingleLoading />}
      {isLoading && <TraingleLoading />}
      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="label">Address</label>
            <textarea
              name="Address"
              className={`textarea rounded-md`}
              type="text"
              placeholder="Enter your Address"
              value={expertiseData.Address}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <label className="label">Working Hours</label>
            <input
              name="hours"
              className={`input rounded-md`}
              type="text"
              placeholder="Enter your Hours"
              value={expertiseData.hours}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div className="flex justify-end ">
            <button className={`formSubmit`} onClick={addPhone}>
              Add Phone
            </button>
          </div>
          <div className="grid grid-cols-3 gap-20">
            {expertiseData?.phoneNumber.map((item, ind) => {
              return (
                <div className="flex">
                  <div>
                    <div className="flex">
                      <div>
                        <label className="label">Phone Number</label>
                      </div>
                      <div className="ml-5 bg-red-600 text-white rounded-md p-1 cursor-pointer">
                        <button onClick={() => deletehandlar(ind, "Phone")}>
                          Delete
                        </button>
                      </div>
                    </div>
                    <input
                      name="description"
                      className={`input`}
                      type="number"
                      placeholder="Enter your Number"
                      value={item}
                      onChange={(e) => handleChange(e, ind, "phone")}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex justify-end ">
            <button className={`formSubmit`} onClick={() => addPhone("email")}>
              Add Email
            </button>
          </div>
          <div className="grid grid-cols-3 gap-20">
            {expertiseData?.email.map((item, ind) => {
              return (
                <div className="flex">
                  <div>
                    <div className="flex">
                      <div>
                        <label className="label">Email</label>
                      </div>
                      <div className="ml-24 bg-red-600 text-white rounded-md p-1 cursor-pointer">
                        <button onClick={() => deletehandlar(ind, "email")}>
                          Delete
                        </button>
                      </div>
                    </div>
                    <input
                      name="description"
                      className={`input`}
                      type="text"
                      placeholder="Enter your Email"
                      value={item}
                      onChange={(e) => handleChange(e, ind, "email")}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex justify-end my-4">
          <button
            onClick={
              expertiseData?.id
                ? (e) => handleUpdate(e)
                : (e) => handleSubmit(e)
            }
            className={`formSubmit`}
          >
            {expertiseData?.id ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminContactAdd;
